import { render, staticRenderFns } from "./GroupsLeagueDetailPage.vue?vue&type=template&id=b5cb0554&scoped=true&"
import script from "./GroupsLeagueDetailPage.vue?vue&type=script&lang=js&"
export * from "./GroupsLeagueDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupsLeagueDetailPage.vue?vue&type=style&index=0&id=b5cb0554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb0554",
  null
  
)

export default component.exports